import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=1207206a&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=1207206a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207206a",
  null
  
)

export default component.exports